import React from 'react';
import { View, ActivityIndicator, Text, StyleSheet } from 'react-native';
import { COLORS, LABELS } from '../constants/config';
import { useTheme } from '../contexts/ThemeContext';

import { tokens } from '@design';
interface LoadingScreenProps {
  message?: string;
}

export default function LoadingScreen({ message = LABELS.loading }: LoadingScreenProps) {
  const { colors } = useTheme();

  // Theme colors for dark mode
  const themeColors = {
    background: colors.background,
    message: colors.textMuted,
  };

  return (
    <View style={[styles.container, { backgroundColor: themeColors.background }]}>
      <ActivityIndicator size="large" color={COLORS.primary} />
      <Text style={[styles.message, { color: themeColors.message }]}>{message}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: COLORS.background,
  },
  message: {
    marginTop: tokens.spacing.absolute["4"],
    fontSize: tokens.typography.paragraph["paragraph font size"],
    color: COLORS.textMuted,
  },
});
